import React from "react";
import CustomData from "pages/_components/CustomData/CustomData";
import CustomText from "pages/_components/CustomText/CustomText";
import { arrayOf, shape, string } from "prop-types";
import FormattedDate from "pages/_components/FormattedDate";

const SolicitDebinConfirmationBody = ({ solicitDebin, recipients, expiryDate }) => (
    <div className="ticket__body echeq-massive-emit">
        <div className="ticket-section three-cols">
            <div className="custom-data">
                <CustomText textType="I18N" text="debin.receiver" className="custom-data-title" />
                <span className="custom-text custom-data-value">{solicitDebin?.beneficiary?.headline}</span>
                <span className="custom-text custom-data-value">{solicitDebin?.beneficiary?.document}</span>
            </div>
            <CustomData
                keepSpaceIfNotitle
                titleTextType="I18N"
                titleText="debin.solicitDebin.amount.label"
                valueText={solicitDebin?.amountField?.amount}
                valueTextType={solicitDebin?.amountField?.currency}
            />
        </div>
        <div className="ticket__divider inside-ticket__body" />
        <div className="view-more-data">
            {!!recipients?.length && (
                <>
                    {recipients.map((recipient) => (
                        <div className="ticket-section three-cols">
                            <CustomData titleText="debin.cbu" titleTextType="I18N" valueText={recipient?.cbu} />
                            <CustomData
                                titleText="debin.emit.emision.label"
                                titleTextType="I18N"
                                valueText={recipient?.accountNumber}
                            />
                            <CustomData titleText="Banco" titleTextType="TEXT" valueText={recipient?.localBank} />
                        </div>
                    ))}
                    <div className="ticket__divider inside-ticket__body" />
                </>
            )}
            {!recipients?.length && solicitDebin?.beneficiary?.accountNumber && (
                <>
                    <div className="ticket-section three-cols">
                        <CustomData
                            titleText="debin.cbu"
                            titleTextType="I18N"
                            valueText={solicitDebin?.beneficiary?.cbu}
                        />
                        <CustomData
                            titleText="debin.emit.emision.label"
                            titleTextType="I18N"
                            valueText={solicitDebin?.beneficiary?.accountNumber}
                        />
                        <CustomData
                            titleText="Banco"
                            titleTextType="TEXT"
                            valueText={solicitDebin?.beneficiary?.localBank}
                        />
                    </div>
                    <div className="ticket__divider inside-ticket__body" />
                </>
            )}
            <div className="ticket-section three-cols">
                <CustomData
                    titleText="debin.credit.account"
                    titleTextType="I18N"
                    valueText={`${solicitDebin?.debinAccount?.accountType}****${solicitDebin?.debinAccount?.shortLabel}`}
                />
                <CustomData
                    titleText="debin.addrecurence.concept.label"
                    titleTextType="I18N"
                    valueText={
                        solicitDebin?.conceptLabel
                            ? `${solicitDebin?.conceptLabel?.id} - ${solicitDebin?.conceptLabel?.name}`
                            : solicitDebin?.concept
                    }
                />
                <CustomData
                    titleText="debin.addrecurence.description.label"
                    titleTextType="I18N"
                    valueText={solicitDebin?.description || "-"}
                />
            </div>
            <div className="ticket-section three-cols">
                {!!expiryDate && (
                    <CustomData
                        titleText="debin.received.dateRange.label"
                        titleTextType="I18N"
                        valueText={<FormattedDate date={expiryDate} dateFormat="DD/MM/YYYY h:mm:ss" />}
                    />
                )}
            </div>
        </div>
    </div>
);

SolicitDebinConfirmationBody.defaultProps = {
    expiryDate: "",
};

SolicitDebinConfirmationBody.propTypes = {
    solicitDebin: shape({}).isRequired,
    recipients: arrayOf(shape()).isRequired,
    expiryDate: string,
};

export default SolicitDebinConfirmationBody;
